import Vue from "vue";

Vue.filter("specialOffer", function(defaultPrice, prices, priceType, exact)
{
    let price;

    if (prices.specialOffer)
    {
        if (exact)
        {
            price = prices.specialOffer[priceType][exact] ? prices.specialOffer[priceType][exact] : defaultPrice;
        }
        else
        {
            price = prices.specialOffer[priceType] ? prices.specialOffer[priceType] : defaultPrice;
        }
    }
    else
    {
        price = defaultPrice;
    }
    if (typeof price === "string" && prices.default.currency === "CHF" )
    {
        price = price.replace("CHF", "");
        price = price.replace(",", ".");
        const splitprice = price.split(".");

        let realprice = "";

        for (let i = 0; i<splitprice.length; i++)
        {
            if (i == splitprice.length - 1)
            {
                realprice += "."+splitprice[i];
            }
            else
            {
                realprice += splitprice[i];
            }

        }
        realprice = Math.round(parseFloat(realprice)*20, 0)/20;
        const format = (new Intl.NumberFormat("it-CH", {
            style: "currency",
            currency: "CHF"
        }).format(realprice));

        return format;
    }
    else
    {
        return price;
    }
});
